<template>
  <div class="menberCenter">
    <iframe
      style="width: 720px; height: 100%; top: 0;left:0; min-height: 650px;"
      v-show="iframeState"
      id="show-iframe"
      frameborder="0"
      name="showHere"
      scrolling="auto"
      :src="varUCHost + 'member'"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "hello",

  data() {
    return {
      iframeState: true,

      goBackState: false,
    };
  },

  mounted() {
    // const oIframe = document.getElementById("show-iframe");

    // const deviceWidth = document.documentElement.clientWidth;

    // const deviceHeight = document.documentElement.clientHeight;

    // oIframe.style.width = deviceWidth + "px";

    // oIframe.style.height = deviceHeight + "px";
    this.$parent.resetHeightFn()
  },

  methods: {
    goBack() {
      this.goBackState = false;

      this.iframeState = false;
    },

    showIframe() {
      this.goBackState = true;

      this.iframeState = true;
    }
  }
};
</script>

<style lang='scss' scoped>
.menberCenter {
  width: 100%;
  min-height: 650px;
  background: url(https://rs2.huanqiucdn.cn/huanqiu/image/www/data/Loading.gif) center no-repeat #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/index/menberCenter/index.vue